var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('WebProfile',{staticClass:"hidden-sm-and-down"}),_c('MobileProfile',{staticClass:"hidden-md-and-up"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }